import { render, staticRenderFns } from "./v-announce.vue?vue&type=template&id=0338feb1&"
import script from "./v-announce.vue?vue&type=script&lang=js&"
export * from "./v-announce.vue?vue&type=script&lang=js&"
import style0 from "./v-announce.vue?vue&type=style&index=0&global=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports